import React, { useEffect, useState } from 'react';
import { storage } from './firebase';
import { Card,Typography,CardContent,Button } from '@mui/material';
import { getStorage, ref, listAll ,getDownloadURL} from "firebase/storage";

const App = () => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    const fetchFiles = async () => {
      const fileList = [];
      const listRef = ref(storage, 'uploads/');

      const res = await listAll(listRef);

      for (let itemRef of res.items) {
        let url = await getDownloadURL(itemRef);
        let name = itemRef.name;
        let isImage = name.match(/\.(jpeg|jpg|gif|png)$/);
        fileList.push({ name, url, isImage });
      }

      setFiles(fileList);
    };

    fetchFiles();
  }, []);

  return (

    <div>

<h1>
  my files
</h1>

      {files.map((file, index) => (
        <Card key={index} style={{ display: 'flex', marginBottom: 10 }}>
          <CardContent style={{ flex: '1 0 auto' }}>
            {file.isImage && <img src={file.url} alt={file.name} style={{ height: 100 }} />}
            <Typography variant="h6">{file.name}</Typography>
          </CardContent>
          <Button
            onClick={() => window.open(file.url)}
            style={{ alignSelf: 'center', marginRight: 10 }}
          >
            Download
          </Button>
        </Card>
      ))}
    </div>
  );
};

export default App;
